import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Image from '@components/atoms/Image';
import { ButtonLink } from '@components/atoms/Button';
import dataLayerPush from '@helpers/dataLayerPush';

const ImageBlock = ({ data: { image, cta } }) => {
  return (
    <Flex
      px={{ base: `2`, md: `36` }}
      direction="column"
      alignItems="center"
      w="100%"
      gap="6"
      my="6">
      <Box maxW="1150px">
        <Image image={image} />
      </Box>
      {cta && (
        <ButtonLink
          variant="primary"
          href={cta.link}
          size="md"
          mt={{ base: 8, md: 0 }}
          onClick={() => {
            dataLayerPush({
              event: `cta_click`,
              interaction: {
                click_text: cta.title,
                link_url: cta.link,
                cta_type: `image_block`
              }
            });
          }}
          data-text={cta.title}>
          <Box>{cta.title}</Box>
        </ButtonLink>
      )}
    </Flex>
  );
};

export default ImageBlock;
